function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Statistic, Button, Skeleton, Divider, Alert, Drawer } from 'antd';
import { Table } from "react-bootstrap";
import Common from "../components/includes/Common";
import { CheckCircleFill, SendCheckFill } from "react-bootstrap-icons";
import { Line } from '@ant-design/charts';
import { Chart } from "react-google-charts";
import moment from "moment";
import Moment from "react-moment";
import { PersonFill, Cash, WalletFill, AwardFill, PeopleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Dashboard = function Dashboard() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    customers = _useState4[0],
    setCustomers = _useState4[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCustomer = _useState6[0],
    setSelectedCustomer = _useState6[1];
  var _useState7 = useState(moment().startOf('month').format()),
    _useState8 = _slicedToArray(_useState7, 2),
    globalFrom = _useState8[0],
    setGlobalFrom = _useState8[1];
  var _useState9 = useState(moment().endOf('month').format()),
    _useState0 = _slicedToArray(_useState9, 2),
    globalTo = _useState0[0],
    setGlobalTo = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    mdata = _useState10[0],
    setMdata = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    errorMessage = _useState12[0],
    setErrorMessage = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showLateFiles = _useState14[0],
    setShowLateFiles = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    lateFiles = _useState16[0],
    setLateFiles = _useState16[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getkeystats/" + globalFrom + "/" + globalTo + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setMdata(response.data.mdata);
        setLateFiles(response.data.lfiles);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {});
  }, []);
  var chartData = [["Mois", "T. Cand.", "D. Valid."], ["JAN.", 550, 330], ["FEV.", 412, 400], ["MAR.", 212, 202], ["AVR.", 172, 50], ["MAI", 612, 580], ["JUIN", 712, 690], ["JUIL.", 412, 402], ["AOUT", 812, 740], ["SEPT.", 512, 340], ["OCT.", 712, 618], ["NOV.", 612, 500], ["DEC.", 412, 240]];
  var statValueClass = {
    fontSize: '40px',
    textAlign: 'center',
    fontWeight: 'bold'
  };
  var statInvertedClass = {
    fontSize: '40px',
    textAlign: 'center',
    fontWeight: 'bold',
    color: "#EEE"
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: errorMessage,
            banner: true
          }), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: mdata != null && /*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: /*#__PURE__*/_jsxs("b", {
              children: ["Dossiers en retard ", lateFiles.length]
            }),
            action: /*#__PURE__*/_jsx(Button, {
              size: "small",
              onClick: function onClick() {
                setShowLateFiles(true);
              },
              type: "text",
              children: /*#__PURE__*/_jsx("b", {
                children: "PARCOURIR"
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: '#1A375D',
              borderRadius: "6px",
              color: '#EEE',
              padding: "25px 10px 25px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(SendCheckFill, {
                size: 25
              }),
              valueStyle: statInvertedClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#EEE'
                },
                children: "Dossier(s) envoy\xE9(s) J"
              }),
              value: mdata.day_sent_count
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#695C5C",
              borderRadius: "6px",
              color: "#EEE",
              padding: "25px 10px 25px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(SendCheckFill, {
                size: 25
              }),
              valueStyle: statInvertedClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#EEE'
                },
                children: "Dossier(s) envoy\xE9(s) S"
              }),
              value: mdata.week_sent_count
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#6A7872",
              borderRadius: "6px",
              color: "#EEE",
              padding: "25px 10px 25px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(SendCheckFill, {
                size: 25
              }),
              valueStyle: statInvertedClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#EEE'
                },
                children: "Dossier(s) envoy\xE9(s) M"
              }),
              value: mdata.month_sent_count
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius",
            style: {
              background: '#7D1A1B',
              color: '#EEE',
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(PeopleFill, {
                size: 25
              }),
              valueStyle: statInvertedClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#EEE'
                },
                children: "Total candidats re\xE7u"
              }),
              value: mdata.candidatCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              background: "#FFFFFF",
              color: "#010101",
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(AwardFill, {
                size: 25
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#010101'
                },
                children: "Total certificats d\xE9livr\xE9s"
              }),
              value: mdata.certCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            children: /*#__PURE__*/_jsx(Chart, {
              chartType: "ScatterChart",
              data: chartData,
              width: "100%",
              height: "300px",
              legendToggle: true,
              options: {
                title: "Evolution nouveaux candidats",
                legend: {
                  position: "bottom"
                },
                colors: ["#A9675C", "#6F8B8A"],
                lineWidth: 1,
                animation: {
                  duration: 5000,
                  easing: "out"
                }
              }
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#010101'
                },
                children: "Total Labo trait\xE9s"
              }),
              value: mdata.laboCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "Total Consultations trait\xE9s"
              }),
              value: mdata.mcheckCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "Total Imageries Trait\xE9s"
              }),
              value: mdata.imCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "Total Audio testes trait\xE9s"
              }),
              value: mdata.audioQuestion
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#010101'
                },
                children: "Total Visio Testes trait\xE9s"
              }),
              value: mdata.visioCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "Total Spirom\xE9tries trait\xE9s"
              }),
              value: mdata.spiroCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 13
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "Total Vaccination trait\xE9s"
              }),
              value: mdata.vaccinCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            style: {
              padding: "35px 10px 35px 10px",
              background: "#F4B91E"
            },
            children: mdata != null ? /*#__PURE__*/_jsx(Statistic, {
              prefix: /*#__PURE__*/_jsx(CheckCircleFill, {
                size: 18
              }),
              valueStyle: statValueClass,
              title: /*#__PURE__*/_jsx("b", {
                children: "TOTAL RAPPORT MEDICAUX"
              }),
              value: mdata.mrCount
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {})]
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "DOSSIERS DE PLUS DE 6 JOURS AVEC CERTIFICATS INTROUVABLES"
      }),
      width: "90%",
      destroyOnClose: true,
      open: showLateFiles,
      onClose: function onClose() {
        setShowLateFiles(false);
      },
      children: /*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: lateFiles.map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              })]
            }, c.id);
          })
        })]
      })
    })]
  });
};
export default Dashboard;